// @ts-check
import styles from './AgencyDirectory.module.css'
import Section from '../Section/Section'
import Header from './Header'
import Nav from './Nav'
import MdcAppLoader from '../MdcAppLoader'
import clsx from 'clsx'

export default function AgencyDirectoryLoading() {
  return (
    <div className={clsx(styles.agencyDirectory, styles.loading)}>
      <Section>
        <Header />
      </Section>
      <Nav />
      <MdcAppLoader />
    </div>
  )
}
